import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import TopBar from "./TopBar";
import { cdn_link } from "./constant";

const Navbar = ({ isTopBarVisible }) => {
  const logo = cdn_link("smk_Logo3.png");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div>
      <TopBar isVisible={isTopBarVisible} />

      <nav
        className={`theme-text-bg shadow-md fixed top-0 left-0 w-full z-40 transition-all duration-300 ${
          isTopBarVisible ? "pt-8" : "pt-0"
        }`}
      >
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          {/* Logo */}
          <div className="text-3xl font-serif font-bold logo-theme">
            <NavLink to="/home">
              <img
                src={logo}
                alt="SMK Decors Logo"
                className="h-12 w-auto"
                loading="lazy"
              />
            </NavLink>
          </div>

          {/* Desktop Links */}
          <div className="hidden md:flex space-x-8">
            <NavLink
              to="/home"
              className={({ isActive }) =>
                isActive
                  ? "text-[#efe8b5] font-semibold"
                  : "text-[#FDE047] font-semibold hover:text-[#F1C27D]"
              }
            >
              Home
            </NavLink>
            <NavLink
              to="/aboutus"
              className={({ isActive }) =>
                isActive
                  ? "text-[#efe8b5] font-semibold "
                  : "text-[#FDE047] font-semibold hover:text-[#F1C27D]"
              }
            >
              About Us
            </NavLink>
            <div
              className="relative"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  isActive
                    ? "text-[#efe8b5] font-semibold py-6"
                    : "text-[#FDE047] font-semibold hover:text-[#F1C27D] py-6"
                }
              >
                Services
              </NavLink>
              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-5 theme-text-bg rounded-md shadow-lg w-48 z-10">
                  <ul>
                    <div className="h-1 w-full bg-[#F1C27D]"></div>
                    <li>
                      <NavLink
                        to="/services/decor"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Event Decor and Lighting
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/catering"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Catering Services
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/photography"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Photography and Videography
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/entertainment"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Entertainment
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/haldi"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Haldi
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/sangeet"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Sangeet
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/venue"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Venue Arrangement
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/corporate"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Corporate Events
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/services/other_services"
                        className="block px-4 py-2 text-[#FDE047] hover:bg-[#782d87] hover:font-semibold transition-colors duration-200"
                        onClick={closeDropdown}
                      >
                        Other Services
                      </NavLink>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive
                  ? "text-[#efe8b5] font-semibold"
                  : "text-[#FDE047] font-semibold hover:text-[#F1C27D]"
              }
            >
              Contact
            </NavLink>
          </div>

          {/* Get Quote Button - Hidden on mobile */}
          <a
            href="/quote"
            className="px-6 py-2 button-theme rounded-full transition"
          >
            Get Quote
          </a>

          {/* Mobile Menu Icon */}
          <div className="md:hidden mr-1">
            <button onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-deepPurple shadow-md py-4">
            <NavLink
              to="/home"
              className="block px-6 py-3 text-[#FDE047] hover:text-[#F1C27D]"
              onClick={toggleMobileMenu}
            >
              Home
            </NavLink>
            <NavLink
              to="/aboutus"
              className="block px-6 py-3 text-[#FDE047] hover:text-[#F1C27D]"
              onClick={toggleMobileMenu}
            >
              About Us
            </NavLink>
            <NavLink
              to="/services"
              className="block px-6 py-3 text-[#FDE047] hover:text-[#F1C27D]"
              onClick={toggleMobileMenu}
            >
              Services
            </NavLink>
            <NavLink
              to="/contact"
              className="block px-6 py-3 text-[#FDE047] hover:text-[#F1C27D]"
              onClick={toggleMobileMenu}
            >
              Contact
            </NavLink>
            <NavLink
              to="/quote"
              className="block px-6 py-3 text-textgold bg-hoverpurple shadow-lg hover:bg-deepPurple"
              onClick={toggleMobileMenu}
            >
              Get Quote
            </NavLink>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
